const steps = [
  {
    n: "01",
    title: "Scope.",
    body:
      "We figure out what you actually need, who else needs to be in the room, and what success looks like. Usually a couple of conversations.",
    testid: "step-scope",
  },
  {
    n: "02",
    title: "Install.",
    body:
      "I work alongside your team for a defined window. We build the framework together. Your team is in the room while we do it.",
    testid: "step-install",
  },
  {
    n: "03",
    title: "Hand off.",
    body:
      "You keep the framework. I step back. We may have a check-in or two after, but the goal is for your team to run it.",
    testid: "step-handoff",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="section-how"
      className="bg-paper"
    >
      <div className="mx-auto max-w-[1100px] px-6 py-20 md:px-10 md:py-28 lg:py-32">
        <h2 className="section-heading max-w-[680px]">How it works.</h2>

        <div className="mt-12 grid grid-cols-1 gap-12 md:mt-16 md:grid-cols-3 md:gap-10">
          {steps.map(({ n, title, body, testid }) => (
            <div key={testid} data-testid={testid}>
              <div
                aria-hidden="true"
                style={{
                  fontFamily: "Fraunces, Georgia, serif",
                  fontWeight: 400,
                  fontSize: "56px",
                  lineHeight: 1,
                  color: "var(--color-terracotta)",
                  fontVariationSettings: '"opsz" 144',
                }}
              >
                {n}
              </div>
              <h3
                className="mt-5 text-deep-lake"
                style={{
                  fontFamily: "Inter, Arial, sans-serif",
                  fontWeight: 500,
                  fontSize: "18px",
                  lineHeight: 1.4,
                }}
              >
                {title}
              </h3>
              <p
                className="mt-3 max-w-[340px]"
                style={{
                  fontFamily: "Inter, Arial, sans-serif",
                  fontSize: "16px",
                  lineHeight: 1.65,
                  color: "rgba(26,58,79,0.78)",
                }}
              >
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
